
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Flight } from '@/types/flight';
import { Control } from 'react-hook-form';
import { FlightUpdateFormValues } from './schemas';

interface FlightSelectorProps {
  control: Control<FlightUpdateFormValues>;
  flights: Flight[];
  loading: boolean;
}

export function FlightSelector({ control, flights, loading }: FlightSelectorProps) {
  if (loading) {
    return (
      <div className="space-y-2">
        <FormLabel>Flight</FormLabel>
        <div className="h-10 w-full bg-muted animate-pulse rounded-md" />
      </div>
    );
  }

  return (
    <FormField
      control={control}
      name="flight_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Flight</FormLabel>
          <Select onValueChange={field.onChange} value={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select a flight to update" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {flights.map((flight) => (
                <SelectItem key={flight.id} value={flight.id}>
                  {flight.flight_number} - {flight.departure_city?.name} → {flight.arrival_city?.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
